module.exports = __webpack_public_path__ + "media/icons/ins-5730ebeb.png";